// UI Constants for Order Summary components
// Only component-specific values, standard theme tokens used directly in components

// Spacing values (component-specific layout)
export const SPACING = {
    main: 5,
    section: 4
}

// Custom border widths for dividers
export const DIVIDER_STYLES = {
    light: {
        borderBottomWidth: '1.34px',
        borderColor: 'gray.500'
    },
    heavy: {
        borderBottomWidth: '2.68px',
        borderColor: 'gray.500'
    }
}

// Component IDs
export const COMPONENT_IDS = {
    orderSummaryHeading: 'order-summary-heading'
}

// Test IDs
export const TEST_IDS = {
    orderSummary: 'sf-order-summary'
}
